import * as React from "react";

const IconLessInactive: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 2"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#CCC" fillRule="evenodd" d="M0 0h10v2H0z"/></svg>;
};

export default React.memo(IconLessInactive);
